
import Share from "@/components/share-button.vue";

import { defineComponent } from "vue";

export default defineComponent({
  components: { Share },
  props: {
    title: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
    print: {
      type: Boolean,
      required: false,
    },
    image: {
      type: String,
      required: false,
    },
  },
});
